type Pager1Props = {
  canGoBack: boolean;
  canGoForward: boolean;
  onPrevious: () => void;
  onNext: () => void;
};

export function Pager1({ canGoBack, canGoForward, onPrevious, onNext }: Pager1Props) {
  return (
    <div className="mt-4 flex justify-end space-x-2">
      <button
        className={`border px-4 py-2 rounded ${!canGoBack ? 'opacity-50 cursor-not-allowed' : ''}`}
        aria-label="Navigate to previous time period"
        onClick={onPrevious}
        disabled={!canGoBack}
      >
        ← Previous
      </button>
      <button
        className={`border px-4 py-2 rounded ${!canGoForward ? 'opacity-50 cursor-not-allowed' : ''}`}
        aria-label="Navigate to next time period"
        onClick={onNext}
        disabled={!canGoForward}
      >
        Next →
      </button>
    </div>
  );
}
